import { registerExtension } from "@core/components/PipelineComponents/ExtensionProvider";
// Alias import so the client override replaces this component. A relative import
// resolves inside the plugin and skips the override.
import AccountCompletionBanner from "@site/components/AccountCompletionBanner";

registerExtension("site.layout.header.below", AccountCompletionBanner, "AccountCompletionBanner");
